export default "/images/framework/Hero.a7af1fcc.svg?a7af1fcc";